import icon2023 from '@assets/graphics/icons/2023-bundle.png';
import invite2023 from '@assets/graphics/carousel/2023/invite.jpg';
import startingSoon2023 from '@assets/graphics/carousel/2023/starting-soon.jpg';
import brb2023 from '@assets/graphics/carousel/2023/brb.jpg';

import icon2021 from '@assets/graphics/icons/2021-bundle.png';
import brb2021 from '@assets/graphics/carousel/2021/brb.jpg';
import countdown2021 from '@assets/graphics/carousel/2021/countdown.jpg';
import overlay2021 from '@assets/graphics/carousel/2021/overlay.jpg';
import startingSoon2021 from '@assets/graphics/carousel/2021/starting-soon.jpg';

import iconRocket from '@assets/graphics/icons/rocket-bundle.png';
import startingSoon1Rocket from '@assets/graphics/carousel/rocket/startingsoon1.jpg';
import startingSoon2Rocket from '@assets/graphics/carousel/rocket/startingsoon2.jpg';
import brbRocket from '@assets/graphics/carousel/rocket/brb.jpg';

import iconDiamond from '@assets/graphics/icons/diamond-icon.png';
import startingSoonDiamond from '@assets/graphics/carousel/diamond/diamond_ss.jpg';
import brbDiamond from '@assets/graphics/carousel/diamond/diamond_brb.jpg';
import countdownDiamond from '@assets/graphics/carousel/diamond/diamond_countdown.jpg';

import iconInstagram from '@assets/graphics/icons/instagram-icon.png';
import carouselInstagram1 from '@assets/graphics/carousel/instagram/instagram1.jpg';
import carouselInstagram2 from '@assets/graphics/carousel/instagram/instagram2.jpg';
import carouselInstagram3 from '@assets/graphics/carousel/instagram/instagram3.jpg';

import icon2024 from '@assets/graphics/icons/2024-bundle-icon.png';
import countdown2024 from '@assets/graphics/carousel/2024/2024_bundle_1.jpg';
import brb2024 from '@assets/graphics/carousel/2024/2024_bundle_2.jpg';
import startingSoon2024 from '@assets/graphics/carousel/2024/2024_bundle_3.jpg';

export const graphics = {
  2024: {
    category: 'graphics',
    name: '2024 Graphics Bundle',
    link: '/graphics/2024',
    thumbnail: icon2024,
    isNew: false,
    shortDescription:
      'Download the new 2024 Play Live graphics bundle to enhance your fundraising stream!',
    features: [
      'New 2023 themed graphics for your stream',
      'New animated screens for your stream',
      '<i>Starting Soon</i> and <i>Be Right Back</i> graphics',
    ],
    images: [countdown2024, brb2024, startingSoon2024],
    downloadLink: 'https://playlive.experience.stjude.org/2024_bundle.zip',
    order: 0,
    show: true,
  },
  2023: {
    category: 'graphics',
    name: '2023 Graphics Bundle',
    link: '/graphics/2023',
    thumbnail: icon2023,
    shortDescription:
      'Download the new 2023 Play Live graphics bundle to enhance your fundraising stream!',
    features: [
      'New 2023 themed graphics for your stream',
      'New animated screens for your stream',
      '<i>Starting Soon</i> and <i>Be Right Back</i> graphics',
      'New social graphics to share on Instagram and X',
    ],
    images: [invite2023, startingSoon2023, brb2023],
    downloadLink:
      'https://playlive.experience.stjude.org/2023_digital_bundle.zip',
    order: 2,
    show: true,
  },
  instagram: {
    category: 'graphics',
    name: 'Instagram Bundle',
    link: '/graphics/instagram',
    thumbnail: iconInstagram,
    shortDescription:
      'Easily share your fundraising campaign progress and engage with your Instagram audience.',
    description:
      'Easily share your fundraising campaign progress and engage with your Instagram audience with these St. Jude PLAY LIVE themed templates',
    images: [carouselInstagram1, carouselInstagram2, carouselInstagram3],
    features: [
      'St. Jude PLAY LIVE themed templates',
      'Engage your Instagram audience about your fundraising',
      'Easily promote your upcoming fundraising campaign',
    ],
    downloadLink: 'https://playlive.experience.stjude.org/graphics_bundle.zip',
    order: 1,
    show: true,
  },
  'fever-fighter': {
    category: 'graphics',
    name: 'Fever Fighter Bundle',
    link: '/graphics/fever-fighter',
    thumbnail: icon2021,
    shortDescription:
      'Download the Fever Fighter graphics bundle to enhance your fundraising stream.',
    description:
      'Download the St. Jude graphics bundle to enhance your fundraising stream. Show your support for the kids of St. Jude with our brand new supporter badge!',
    images: [brb2021, countdown2021, overlay2021, startingSoon2021],
    features: [
      'Fever Fighter themed graphics for your stream',
      'New animated screens for your stream',
      'St. Jude supporter badge',
      '<i>Starting Soon</i> and <i>Be Right Back</i> graphics',
    ],
    downloadLink: 'https://playlive.experience.stjude.org/2021_assets.zip',
    order: 4,
    show: true,
  },
  rocket: {
    category: 'graphics',
    name: 'Rocket Ship Bundle',
    link: '/graphics/rocket',
    thumbnail: iconRocket,
    shortDescription:
      'Download the Rocket Ship graphics bundle to enhance your fundraising stream.',
    images: [startingSoon1Rocket, startingSoon2Rocket, brbRocket],
    features: [
      'Themed graphics for your stream',
      'St. Jude supporter badge',
      '<i>Starting Soon</i> and <i>Be Right Back</i> graphics',
    ],
    downloadLink: 'https://playlive.experience.stjude.org/overlays.zip',
    order: 5,
    show: true,
  },
  diamond: {
    category: 'graphics',
    name: '60th Anniversary Diamond Bundle',
    link: '/graphics/diamond',
    thumbnail: iconDiamond,
    shortDescription:
      'Download the new St. Jude 60th anniversary diamond graphics bundle to enhance your fundraising stream!',
    images: [startingSoonDiamond, brbDiamond, countdownDiamond],
    features: [
      '60th anniversary themed graphics for your stream',
      'New animated screens for your stream',
      'Animated camera overlay',
      '<i>Starting Soon</i> and <i>Be Right Back</i> graphics',
    ],
    downloadLink: 'https://playlive.experience.stjude.org/2022_bundle.zip',
    order: 3,
    show: true,
  },
};
